<template>
    <component v-bind:is="content"></component>
</template>
<script>
import { mapGetters } from 'vuex'
import Hobel from '@/components/faq/Hobel.vue'
import Fleetpool from '@/components/faq/Fleetpool.vue'
export default {
  components: { Hobel, Fleetpool },
  computed: {
    ...mapGetters(['tenant']),
    content() {
      return this.tenant.knumber === 'K10122' ? 'hobel' : 'fleetpool'
    }
  }
}
</script>
